import { Button } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

type ButtonProps = {
	title: string;
	onClick: any;
	style: SxProps<Theme>;
	icon?: any;
	positionIcon?: "start" | "end";
};

export default function ButtonComponent({
	title,
	onClick,
	style,
	icon,
	positionIcon,
}: ButtonProps) {
	return (
		<Button
			sx={{
				maxWidth: "100%",
				height: "100%",
				backgroundColor: "#FFA890",
				color: "#FFFFFF",
				borderRadius: "8px",
				fontWeight: "bold",
				border: "none",
				"&:hover": {
					backgroundColor: "#FFA890",
					color: "white",
					border: "none",
				},
			}}
			variant="outlined"
			onClick={onClick}
		>
			{title}
		</Button>
	);
}
